module.exports = __webpack_public_path__ + "static/media/dummy5.499ee006.png";